<template>
  <div class="builder-actions">
    <div>
      <el-tooltip
        content="Start a new project"
        placement="top"
        effect="light"
      >
        <el-button @click="doNew()"
          ><i class="far fa-file mr-1"></i> New</el-button
        >
      </el-tooltip>
      <el-tooltip
        content="Save the project file on your machine"
        placement="top"
        effect="light"
      >
        <el-button @click="save()" type="primary"
          ><i class="far fa-save mr-1"></i> Save</el-button
        >
      </el-tooltip>
      <el-tooltip
        content="Load a previously saved project file"
        placement="top"
        effect="light"
      >
        <label class="pointer el-button">
          <i class="fas fa-upload mr-1"></i> Load
          <input
            accept="application/json"
            type="file"
            @change="loadDataFromFile($event.target.files)"
            style="display:none"
          />
        </label>
      </el-tooltip>
      <el-tooltip
        v-if="existsSample"
        content="Load sample entities"
        placement="top"
        effect="light"
      >
        <el-button @click="sample()"
          ><i class="far fa-compass"></i> Sample</el-button
        >
      </el-tooltip>

      <el-tooltip
        v-if="hasManyVersions"
        content="Version"
        placement="top"
        ref="tooltip3"
        effect="light"
      >
        <el-select
          v-model="version"
          placeholder="Version"
          class="version-select"
        >
          <el-option
            v-for="version in versions"
            :key="version"
            :label="version"
            :value="version"
          ></el-option>
        </el-select>
      </el-tooltip>

      <span
        v-if="!isRecentVersion"
        class="ml-2 text-red-400"
      >
        <i class="fas fa-chevron-left mr1"></i> New version
        available
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'app-builder-actions',

  computed: {
    ...mapGetters({
      scaffold: 'scaffold/current',
      existsSample: 'builder/existsSample',
      versions: 'scaffold/versions',
      hasManyVersions: 'scaffold/hasManyVersions',
    }),

    isRecentVersion() {
      const scaffold = this.scaffold;

      if (!scaffold) {
        return false;
      }

      return (
        scaffold.availableVersions[0] === scaffold.version
      );
    },

    version: {
      get() {
        return this.$store.getters['scaffold/current']
          .version;
      },

      async set(value) {
        try {
          await this.$confirm(
            'Are you sure? Current project will be discarded.',
            'Confirm',
            {
              confirmButtonText: 'Yes',
              cancelButtonText: 'No',
              type: 'warning',
            },
          );
        } catch (error) {
          return;
        }

        return this.$store.dispatch(
          'builder/loadVersionAndNewProject',
          value,
        );
      },
    },
  },

  methods: {
    ...mapActions({
      loadDataFromFile: 'builder/loadDataFromFile',
    }),

    save() {
      this.$store.dispatch('builder/downloadData');
    },

    async doNew() {
      try {
        await this.$confirm(
          'Are you sure? Current project will be discarded.',
          'Confirm',
          {
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            type: 'warning',
          },
        );
      } catch (error) {
        return;
      }

      return this.$store.dispatch('builder/newProject');
    },

    async pro() {
      try {
        await this.$confirm(
          'Are you sure? Current project will be discarded. You can use the current project on the pro version by saving the JSON file on your machine and loading it on the pro modeling tool.',
          'Confirm',
          {
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            type: 'warning',
          },
        );
      } catch (error) {
        return;
      }

      window.location.href = '/scaffold/nodejs';
    },

    async basic() {
      try {
        await this.$confirm(
          'Are you sure? Current project will be discarded.',
          'Confirm',
          {
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            type: 'warning',
          },
        );
      } catch (error) {
        return;
      }

      window.location.href = '/scaffold/nodejs-basic';
    },

    async sample() {
      try {
        await this.$confirm(
          'Are you sure? Current project will be discarded.',
          'Confirm',
          {
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            type: 'warning',
          },
        );
      } catch (error) {
        return;
      }

      /* eslint-disable */
      return this.$store.dispatch(
        'builder/loadDataFromSample',
      );
    },
  },
};
</script>

<style></style>
